<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vbiZ9b/tc-custom/9781416998686.jpg?1730494028330" alt="This image is the cover for the book Dragon Games, The Books of Umber"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dragon Games, The Books of Umber
      </h1>
      <p class="bookDescription body article font2">
        <p>A surprise visitor to the Aerie provides devastating news for Happenstance about his past--but it's the future that Umber and Hap must contend with: they need to learn all they can about Meddlers if they are to discover what Hap's role in Umber's mission is to be. And that means a risky trip to The Inferno, where Caspar has taken the key pages of Umber's research. But that's only one of the perilous journeys Umber has in mind for his mysterious ward: Umber's nemesis, the wheeling and dealing Hameron, has acquired some dragon eggs, and Umber can't resist the opportunity to study a new magical species, even if it means a trip to the corrupt kingdom of Sarnica. But when he and Hap see what the warlord of Sarnica has planned for the dragon hatchlings at the upcoming Dragon Games, Umber's quest for knowledge turns into a dangerous rescue operation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        P. W. Catanese
      </h2>
      
      <p class="authorDescription body article">P. W. Catanese is the author of ten fantasy-adventure novels. His books have been received with critical acclaim and have been translated into five foreign languages. His Books of Umber trilogy has been nominated for six regional book awards, including the Texas Bluebonnet award, the Florida&rsquo;s Sunshine State Young Readers award, and the Pacific Northwest Library Association&rsquo;s Young Reader&rsquo;s Choice awards. He lives in Connecticut. When he&rsquo;s not writing books, Catanese draws cartoons, works for an advertising agency, and tries very hard to respond to every message from his readers. Meet him at PWCatanese.com, and on Facebook, Twitter, and Instagram.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aladdin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2f1a3efb